/**
 * setTimeout 最大延时值
 * @description
 * setTimeout 是使用 Int32 来存储延时参数值
 * 所以最大值为 2^31-1
 */
var SETTIMEOUT_MAX_MILLISECOND = Math.pow(2, 31) - 1;
/**
 * 延时
 * @param millisecond 毫秒
 */

export default function sleep(millisecond) {
  return new Promise(function (resolve) {
    var safeMillisecond = Number.isSafeInteger(millisecond) && millisecond > 0 ? millisecond : 0;
    var ms = safeMillisecond > SETTIMEOUT_MAX_MILLISECOND ? SETTIMEOUT_MAX_MILLISECOND : safeMillisecond;
    setTimeout(resolve, ms);
  });
}